<svelte:options tag="user-login" />

<div id="user-actions" class="action-btn">
  <div on:click={toggleUserActions} href={accessLoginUrl} id="user-image">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      id="user-icon"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style="overflow: visible;enable-background: new 0 0 512 512;"
      xml:space="preserve"
      aria-label="user login icon"
    >
      <style type="text/css">
        .st0 {
          fill: var(--ripe-app-header-icon-bg, #c0c0c0);
        }
        .st1 {
          fill: #ffffff;
        }
      </style>
      <g>
        {#if typeof userrequestprocessed === 'string'}
          <!-- Exclamation Mark  -->
          <circle class="st0" cx="256" cy="256" r="256" />
          <g class="st1">
            <path d="M244.9,286.8l-5-124h34.2l-5,124H244.9z" />
            <path
              d="M235.3,328.3c0-6.9,1.8-12.1,5.5-15.6c3.7-3.5,9.1-5.3,16.1-5.3c6.8,0,12.1,1.8,15.8,5.4
              c3.7,3.6,5.6,8.8,5.6,15.5c0,6.5-1.9,11.6-5.7,15.3c-3.8,3.7-9,5.6-15.8,5.6c-6.9,0-12.2-1.8-16-5.5
              C237.2,340.1,235.3,334.9,235.3,328.3z"
            />
          </g>
        {:else if userrequestprocessed && userloggedin}
          <!-- User Image Icon -->
          <circle class="hover-ring" cx="256" cy="256" r="256" />
          <image id="user-img" xlink:href={accessPictureUrl} x="0" y="0" />
          <circle id="user-ring" cx="256" cy="256" r="256" />
        {:else if userrequestprocessed || !usercookie}
          <!-- Login Arrow Icon-->
          <circle class="hover-ring" cx="256" cy="256" r="256" />
          <path
            class="st0"
            d="M256,0 C397.384896,0 512,114.615104 512,256 C512,397.384896 397.384896,512 256,512 C114.615104,512
            0,397.384896 0,256 C0,114.615104 114.615104,0 256,0 Z M318,162 L276.875,162 C273.64375,162 271,164.629687
            271,167.84375 L271,167.84375 L271,179.53125 C271,182.745313 273.64375,185.375 276.875,185.375
            L276.875,185.375 L318,185.375 C330.973958,185.375 341.5,195.845052 341.5,208.75 L341.5,208.75 L341.5,302.25
            C341.5,315.154948 330.973958,325.625 318,325.625 L318,325.625 L276.875,325.625 C273.64375,325.625
            271,328.254687 271,331.46875 L271,331.46875 L271,343.15625 C271,346.370313 273.64375,349 276.875,349
            L276.875,349 L318,349 C343.947917,349 365,328.059896 365,302.25 L365,302.25 L365,208.75 C365,182.940104
            343.947917,162 318,162 L318,162 Z M196.645338,171.728784 L187.068745,181.307074 C184.723457,183.652778
            184.772317,187.415678 187.166465,189.663644 L242.427313,243.321618 L120.86322,243.321618
            C117.638449,243.321618 115,245.960535 115,249.185877 L115,262.869149 C115,266.094492 117.638449,268.733409
            120.86322,268.733409 L242.427313,268.733409 L187.166465,322.342514 C184.821177,324.639349
            184.772317,328.402248 187.068745,330.699083 L196.645338,340.277374 C198.941765,342.574209
            202.655138,342.574209 204.951566,340.277374 L285.277679,260.132495 C287.574107,257.83566
            287.574107,254.121629 285.277679,251.824794 L204.951566,171.679915 C202.655138,169.431949
            198.941765,169.431949 196.645338,171.728784 Z"
          />
        {/if}
      </g>
    </svg>
  </div>

  {#if typeof userrequestprocessed === 'string'}
    <div id="user-actions-w">
      <ul id="user-actions-list">
        <li>
          <a href={getAccessLoginUrl()}>Retry Login</a>
        </li>
      </ul>
    </div>
  {:else if userrequestprocessed && userloggedin}
    <div id="user-actions-w">
      <ul id="user-actions-list">
        <li>
          <a href={accessProfileUrl}>
            {user.firstName}
            {user.lastName}
          </a>
        </li>
        {#if user.uuid}
          <li>
            <a href={getAccessLogoutUrl()} title="Logout the current user">Logout</a>
          </li>
        {/if}
        {#if userlinks.length > 0}
          {#each userlinks as link}
            <li>
              <a href={link.url}>{link.title}</a>
            </li>
          {/each}
        {/if}
      </ul>
    </div>
  {:else if userrequestprocessed}
    <div id="user-actions-w">
      <ul id="user-actions-list">
        <li>
          <a href={getAccessLoginUrl()}>Go to Login</a>
        </li>
      </ul>
    </div>
  {/if}
</div>

<script>
  export let logoutredirecturl = null
  export let accessurl = null
  export let pictureurl = null
  export let userloggedin = false
  export let userrequestprocessed = null // fake Option, { null || true || errorString}
  export let userlinks = []

  let showUserActions = false
  let user = { uuid: null }
  const usercookie = document.cookie.includes('crowd.ripe.hint')

  $: accessLoginUrl = (accessurl && accessurl.slice(0, 8) !== 'https://' && `https://${accessurl}`) || accessurl
  $: accessPictureUrl = pictureurl || `${accessLoginUrl}/picture/${user.uuid}`
  $: accessUserUrl = `${accessLoginUrl}/user/profile`
  $: accessProfileUrl = `${accessLoginUrl}/profile`
  $: userloggedin = userloggedin
  $: userrequestprocessed = userrequestprocessed

  $: if (accessLoginUrl && !userrequestprocessed && usercookie) {
    fetch(accessUserUrl, { credentials: 'include', cache: 'no-store' })
      .then(accessUserResponse => {
        if (accessUserResponse && accessUserResponse.status === 200) {
          userloggedin = true
          accessUserResponse.json().then(r => {
            userrequestprocessed = true
            user = r
          })
        } else {
          userrequestprocessed = userrequestprocessed || true
        }
      })
      .catch(e => {
        userloggedin = false
        userrequestprocessed = 'Login not available'
      })
  }

  const toggleUserActions = e => {
    // unhappy with this.
    // It is sort of used as a conditional branch
    // This function is sometimes called not as event callback,
    // but instead as a stand-alone function.
    // In that case there's no event data, of course
    if (e) {
      e.preventDefault()
    }
    if (!userloggedin) {
      window.location.href = getAccessLoginUrl()
      return
    }
    showUserActions = !showUserActions
    if (showUserActions) {
      return window.setTimeout(() => window.addEventListener('click', handleUserActionsClose), 0)
    }
    return window.removeEventListener('click', handleUserActionsClose)
  }

  const handleUserActionsClose = e => {
    const clickedElemInShadowDom = e.composedPath()[0]
    const canClickWhileOpen = clickedElemInShadowDom.classList.contains('clickable')
    if (canClickWhileOpen) {
      return
    }
    toggleUserActions()
  }

  const getAccessLoginUrl = () => {
    const currentUrl = window.location.href
    return `${accessLoginUrl}/?originalUrl=${encodeURI(currentUrl)}`
  }

  const getAccessLogoutUrl = () => {
    let redirectUrl = window.location.href
    if (logoutredirecturl) {
      redirectUrl = logoutredirecturl
    }
    return `${accessLoginUrl}/logout?originalUrl=${encodeURI(redirectUrl)}`
  }
</script>

<style type="text/scss">
  .action-btn {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 40px;
    height: 40px;
    position: relative;
    background: none;
    font-family: var(--ripe-app-font-family), Helvetica, Arial, Sans-serif;
    font-weight: 400;
    user-select: none;
    // pff, this should gap on the parent.
    // but chromium can't deal with it yet.
    margin-left: 1rem;

    @media print {
      display: none;
    }

    & button {
      padding: 0;
      background: none;
      border: none;
    }

    svg circle#user-ring {
      stroke: var(--ripe-app-header-icon-bg, #c0c0c0);
      stroke-width: 32;
    }
  }

  #user-actions:hover circle.hover-ring {
    fill: var(--ripe-app-header-icon-hover, #131f48);
    stroke: none;
    transform: scale(1.25);
    transform-origin: 256px 256px;
    transition: 0.1s transform ease-in;
  }

  #user-image {
    border: none;
    background: none;
    padding: 0;
    position: relative;
    z-index: 10;
    image {
      clip-path: circle(50% at 50%);
      width: 100%;
      height: 100%;
      transform: scale(1.05);
      transform-origin: 50% 50%;
    }
  }

  .action-btn svg {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 40px;
    height: 40px;
    fill: none;
    // stroke-width: 32;
  }

  #user-icon {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 40px;
    height: 40px;

    circle.hover-ring {
      fill: none;
      stroke: none;
    }

    &:hover {
      cursor: pointer;
    }
  }

  #user-actions-w {
    display: none;
    position: absolute;
    /* the safety hover-overlap starts
    working below 'top' */
    top: 25px;
    right: -9px;
    width: 190px;
    z-index: 1;
  }

  #user-actions-w {
    cursor: pointer;
  }

  ::slotted(roll-over) {
    display: none;
  }

  #user-actions:hover ::slotted(roll-over) {
    display: block;
  }

  #user-actions:hover #user-actions-w,
  #question-mark-actions:hover roll-over {
    display: block;
  }

  #user-actions-list {
    background: var(--ripe-app-navbar-background, #080037);
    z-index: 999999;
    min-width: 190px;
    // position: absolute;
    list-style: none;
    padding: 0;
    margin: 0;
    // right: -12px;
    // top: 55px;
    margin-top: 30px;

    &:after {
      // @media only screen and (max-width: 700px) {
      //   // make dropdown appear underneath center of user image
      //   right: 19px;
      // }

      top: 10px;
      right: 18px;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-bottom-color: var(--ripe-app-navbar-background, #080037);
      border-width: 10px;
      margin-left: -10px;
    }

    li {
      padding: 12px 16px 12px 16px;
      list-style: none;
      text-align: left;
      color: var(--ripe-app-navbar-menuitem, #c0c0c0);
    }

    // The name of the loggedin user
    li:first-child {
      border-bottom: 1px solid #36334a;
      a {
        color: var(--ripe-app-navbar-indicator, #f59331);
        font-weight: normal;
      }
    }

    a:hover {
      color: white;
      opacity: 1;
    }

    a {
      display: block;
      color: var(--ripe-app-navbar-menuitem, #c0c0c0);
      text-decoration: none;
    }
  }

  @media only screen and (max-width: 400px) {
    .action-btn {
      margin-left: 0.5rem;
    }
  }
</style>
